import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import ConnectedAssigneeSelect from '../../task-components/ConnectedAssigneeSelect';

const TaskDetailsAssignedTo = ({ taskId }) => {
  return (
    <div className="flex items-center py-2.5 pr-2">
      <div className="w-32 shrink-0 flex items-center gap-2">
        <img src="/images/icons/members-gray.svg" alt="" className="w-4 h-4 shrink-0 opacity-50" />
        <span className="text-[13px] text-[rgba(15,15,25,0.5)] font-medium">
          <FormattedMessage id="ASSIGNED_TO" defaultMessage="Assigned to" />
        </span>
      </div>
      <div className="flex-1 flex justify-end">
        <ConnectedAssigneeSelect iconSize={26} showNames taskId={taskId} />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  taskId: getOpenedTaskId(state),
});

export default connect(mapStateToProps)(TaskDetailsAssignedTo);
